import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { OrderDetailContent } from "./OrderDetailContent";

interface OrderDetailModalProps {
  open: boolean;
  guidOrderId: string | null;
  wasResolved: boolean;
  onClose: () => void;
  /** When false, hide the AttachOrderForm section entirely (read-only). Default true. */
  showAttachForm?: boolean;
  /**
   * When true, render a read-only summary of the AssociatedMetaData between
   * the Order Context and Order Events sections. Default false.
   */
  showAssociatedMetadata?: boolean;
}

/**
 * Modal-style host for the order detail content. Mirrors OrderSidePanel but
 * renders inside a Radix Dialog. The body content (OrderDetailContent) is
 * shared between both hosts so behavior stays identical.
 */
export function OrderDetailModal({
  open,
  guidOrderId,
  wasResolved,
  onClose,
  showAttachForm = true,
  showAssociatedMetadata = false,
}: OrderDetailModalProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(next: boolean) => {
        if (!next) onClose();
      }}
    >
      <DialogContent className="md:max-w-[480px] lg:max-w-xl max-h-[90vh] overflow-hidden flex flex-col p-0 gap-0">
        <DialogHeader className="p-3 border-b">
          <DialogTitle className="text-sm font-semibold text-left">
            Order Details
          </DialogTitle>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto p-3">
          <OrderDetailContent
            guidOrderId={guidOrderId}
            wasResolved={wasResolved}
            showAttachForm={showAttachForm}
            showAssociatedMetadata={showAssociatedMetadata}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
